import React from 'react';
import Parent from './components/Parent'

const App = () => {
  return (
    <Parent />
  );
}

export default App;